import React from 'react';
import { FileText } from '../../../../shared/assets/AppIcons';
import InvoiceForm from '@/modules/accounting/components/income/InvoiceForm';
import {
  CreateFormCancelButton,
  CreateFormDialog,
  CreateFormSubmitButton,
} from '../../../../shared/components/CreateFormDialog';

export default function CreateInvoiceDialog({ open, onOpenChange, clients, formState }) {
  return (
    <CreateFormDialog
      busy={formState.isSubmitting}
      open={open}
      onOpenChange={onOpenChange}
      icon={FileText}
      title="Nuova Fattura"
      className="accounting-form-dialog"
      footer={
        <>
          <CreateFormCancelButton onClick={formState.onCancel} disabled={formState.isSubmitting} />
          <CreateFormSubmitButton
            form="invoice-form"
            saving={formState.isSubmitting}
            disabled={!clients?.length}
          >
            Salva fattura
          </CreateFormSubmitButton>
        </>
      }
    >
      <InvoiceForm clients={clients} {...formState} renderActions={false} enableCustomFields />
    </CreateFormDialog>
  );
}
